<template>
	<span v-if="state==='loaded'" class="ref-link">
		<template v-for="(r, idx) of header.rows">
			<span class="ref-link-row">
				<sym-icon :name="r.icon"></sym-icon>
				<span v-if="r.subtitle" style="opacity:0.5">{{ r.subtitle }}</span>
				<object-link :src-type="r.srcType" :src-sub-type="r.srcSubType" :src-id="r.srcId">{{ r.title }}</object-link>
			</span>
		</template>
	</span>
</template>

<script setup lang="ts">
import {ref, watchEffect} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {SrcType} from "@t/meta/SourceType.ts";
import {RowObjectHeader} from "@t/fd/editor/References.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ObjectLink from "@fd/helpers/ObjectLink.vue";

const props = defineProps<{
	customer?: number;
	branch?: number;
	person?: number;

	srcType?: number;
	srcId?: number;
}>();

const env = injectEnv();
const state = ref<string>("loading");
const header = ref<RowObjectHeader|null>(null);

watchEffect((onCleanup) => {
	state.value = "loading";
	let endpoint;
	if (props.customer) {
		// ask for trinity
		endpoint = env.net.urlParam("api/parties/header", "customer", props.customer);
		if (props.branch) endpoint = env.net.urlParam(endpoint, "branch", props.branch);
		if (props.person) endpoint = env.net.urlParam(endpoint, "person", props.person);
	} else {
		// ask for srcType object
		switch (props.srcType) {
			case SrcType.OPPORTUNITY:
				endpoint = "api/opportunities/"+props.srcId+"/header";
				break;
			case SrcType.BUSCASE:
				endpoint = "api/buscases/"+props.srcId+"/header";
				break;
			case SrcType.PROBLEM:
				endpoint = "api/problems/"+props.srcId+"/header";
				break;
			case SrcType.CAMPAIGN:
				endpoint = "api/campaigns/"+props.srcId+"/header";
				break;
			case SrcType.TASK:
				endpoint = "api/tasks/"+props.srcId+"/header";
				break;
			case SrcType.EVENT:
				endpoint = "api/events/"+props.srcId+"/header";
				break;
		}
	}

	env.net.fetch(endpoint)
		.then((resp) => {
			if (resp.ok) {
				return resp.json();
			}
			throw new Error("Unable to load header for "+props.srcType+"/"+props.srcId);
		})
		.then((h: RowObjectHeader) => {
			header.value = h;
			state.value = "loaded";
		})
		.catch((err) => {
			console.error(err);
			state.value = "error";
		});
});
</script>

<style>
.ref-link {
	display: flex;
	flex-direction: row;
	column-gap: 4px;
	flex-wrap: wrap;
	align-items: baseline;
}

.ref-link-row {
	display: flex;
	flex-direction: row;
	column-gap: 4px;
	flex-wrap: wrap;
	align-items: baseline;
}
</style>